import React from "react";
import { Row, Col, Button } from "antd";
import { Swiper, SwiperSlide } from "swiper/react";
import { SendOutlined } from "@ant-design/icons";
import { SiHey } from "react-icons/si";
import Img1 from "../assets/testimonals/1.png";
import Img2 from "../assets/iconsmaking.png";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Autoplay, Pagination, Navigation } from "swiper/modules";

function Feedback() {
  return (
    <section className="main-feedback py-16 md:py-32 lg:py-40 bg-[#6cc5bf]">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <Row gutter={[24, 32]} align="middle" justify="center">
          {/* Left Content Section */}
          <Col xs={24} md={24} lg={12}>
            <div className="main-feedback-text">
              <h5 className="font-custom text-start text-2xl md:text-3xl pb-3 md:pb-5 text-[#fff]">
                <span className="text-[#fff] text-3xl md:text-4xl lg:text-5xl">_</span> Valuable
                Feedback
              </h5>
              <h2
                className="font-custom font-bold text-start text-3xl md:text-4xl lg:text-5xl text-[#fff] w-full md:w-[90%] lg:w-[80%] leading-tight md:leading-snug lg:leading-[70px]"
              >
                High Quality Printing Service In California
              </h2>
              <p className="text-[#fff] font-outfit text-base md:text-lg lg:text-[20px] w-full md:w-[80%] lg:w-[60%] pt-4 md:pt-5">
                Beautiful, customizable template, with a ton of blocks to
                create an amazing website that
              </p>
              <Button
                className="relative font-custom text-base md:text-lg font-semibold
                  overflow-hidden border-2 border-teal-400 rounded-full
                  px-4 md:px-6 h-[40px] md:h-[45px] transition-all duration-300 ease-in-out
                  text-teal-600 bg-white hover:!bg-[#6cc5bf] hover:!border-[#000]
                  hover:!text-white shadow-[4px_4px_0_0_#14b8a6] md:shadow-[6px_6px_0_0_#14b8a6]
                  hover:shadow-[0px_0px_0_0_#14b8a6]
                  active:shadow-[0_2px_0_0_#14b8a6]
                  active:translate-y-[4px] group mt-6 md:mt-8"
                type="default"
                icon={<SendOutlined />}
              >
                <span className="hidden sm:inline">Let's Talk — Send A Message</span>
                <span className="sm:hidden">Let's Talk</span>
                <SiHey className="ml-2" />
              </Button>
            </div>
          </Col>

          {/* Right Swiper Section */}
          <Col xs={24} md={24} lg={12}>
            <div className="testimonial-swiper-wrapper pb-12 md:pb-16">
              <Swiper
                spaceBetween={20}
                centeredSlides={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                navigation={window.innerWidth >= 768}
                pagination={{
                  clickable: true,
                }}
                modules={[Autoplay, Pagination, Navigation]}
                className="testimonial-swiper"
              >
                {[...Array(9)].map((_, index) => (
                  <SwiperSlide key={index}>
                    <div className="slider-wrapper p-3 md:p-5">
                      <div className="min-h-[320px] md:h-80 testimonials-bio p-4 md:p-5 rounded-lg bg-[#fff]">
                        {/* Header Section */}
                        <ul className="flex flex-col sm:flex-row pb-4 md:pb-5 pt-3 md:pt-5 items-start sm:items-center gap-4">
                          <li className="flex-shrink-0">
                            <img 
                              src={Img1} 
                              alt="Mathias Herasen" 
                              className="w-12 h-12 md:w-16 md:h-16 rounded-full object-cover"
                            />
                          </li>
                          <li className="flex-1">
                            <h4 className="font-custom text-lg md:text-xl lg:text-[25px] font-bold">
                              Mathias Herasen
                            </h4>
                            <p className="font-custom text-sm md:text-base lg:text-[18px]">
                              Founder of{" "}
                              <span className="text-[#6cc5bf]">GamerPay</span>
                            </p>
                          </li>
                          <li className="flex-shrink-0 hidden sm:block">
                            <img 
                              src={Img2} 
                              alt="Quote icon" 
                              className="w-8 h-8 md:w-10 md:h-10"
                            />
                          </li>
                        </ul>

                        {/* Testimonial Text */}
                        <p className="w-full md:w-[85%] lg:w-[70%] px-2 md:px-5 py-3 md:py-5 font-custom text-sm md:text-base text-gray-700">
                          "I designed shirts for my family reunion, and the
                          results blew me away. The colors were vibrant, the
                          material was soft, and everyone loved them."
                        </p>

                        {/* Service Badge */}
                        <span className="text-[#6cc5bf] text-base md:text-lg lg:text-[20px] font-custom px-2 md:px-5 font-semibold inline-block">
                          " AMAZING SERVICE "
                        </span>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </div>

      <style dangerouslySetInnerHTML={{__html: `
        .testimonial-swiper-wrapper {
          position: relative;
        }

        .testimonial-swiper .swiper-button-next,
        .testimonial-swiper .swiper-button-prev {
          color: #fff !important;
          width: 40px;
          height: 40px;
        }

        .testimonial-swiper .swiper-button-next:after,
        .testimonial-swiper .swiper-button-prev:after {
          font-size: 20px;
        }

        .testimonial-swiper .swiper-pagination {
          bottom: 0 !important;
        }

        .testimonial-swiper .swiper-pagination-bullet {
          background: #fff !important;
          opacity: 0.5;
        }

        .testimonial-swiper .swiper-pagination-bullet-active {
          background: #14b8a6 !important;
          opacity: 1;
        }

        /* Hide navigation arrows on mobile */
        @media (max-width: 767px) {
          .testimonial-swiper .swiper-button-next,
          .testimonial-swiper .swiper-button-prev {
            display: none !important;
          }
        }

        /* Adjust navigation position on tablet */
        @media (min-width: 768px) and (max-width: 1024px) {
          .testimonial-swiper .swiper-button-next {
            right: 10px;
          }
          .testimonial-swiper .swiper-button-prev {
            left: 10px;
          }
        }
      `}} />
    </section>
  );
}

export default Feedback;